module.exports = __webpack_public_path__ + "img/1565023833.e408daff.jpg";